/*
pwaflight
pwahotel
pwarail
pwabus
pwacab
desktopflight
desktophotel
desktoprail
desktopbus
desktopcab
*/
var SKYWALKER_API_PATHS_CAB = {
  pwaHome: '/pwacab',
  desktopHome: '/desktopcab'
};
var SKYWALKER_TEMPLATE_ID_CAB = {
  recentSearchMweb: 'GI_RECENT_SEARCH',
  recentSearchDweb: 'GI_RECENT_SEARCH'
};

export { SKYWALKER_TEMPLATE_ID_CAB as S, SKYWALKER_API_PATHS_CAB as a };
